import React from "react";

const MenuCloseIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.92912 4.92903C5.31965 4.53851 5.95281 4.53851 6.34334 4.92903L19.0713 17.657C19.4618 18.0475 19.4618 18.6806 19.0713 19.0712C18.6807 19.4617 18.0476 19.4617 17.657 19.0712L4.92912 6.34324C4.5386 5.95272 4.5386 5.31955 4.92912 4.92903Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.92879 19.0711C4.53826 18.6806 4.53826 18.0474 4.92879 17.6569L17.6567 4.92899C18.0472 4.53846 18.6804 4.53846 19.0709 4.92899C19.4614 5.31951 19.4614 5.95267 19.0709 6.3432L6.343 19.0711C5.95248 19.4616 5.31931 19.4616 4.92879 19.0711Z"
        fill="white"
      />
    </svg>
  );
};

export default MenuCloseIcon;
